import {CURRENT_STATUSES} from "../constants/ProductDetails.constants";

export const getStatusStyle = (currentStatus) => {

    let style = "title";

    //coloring only for new, closing soon, status override values
    if (
        currentStatus !== CURRENT_STATUSES.Called &&
        currentStatus !== CURRENT_STATUSES.Matured &&
        currentStatus !== CURRENT_STATUSES.Closed &&
        currentStatus !== CURRENT_STATUSES.Active
    ) {
        style += " tds-current-offering-search-results-color ";
        if (currentStatus === CURRENT_STATUSES.New) {
            style += "status-new";
        } else if (currentStatus === CURRENT_STATUSES.ComingSoon) {
            style += "status-coming-soon";
        } else {
            //ClosingSoon or any status override
            style += "status-closing-soon";
        }
    }
    return style;
};
